import {
    /** FETCH APPLICATION  */
    FETCH_EDITCAREPROVIDERDATA_FULFILLED,
    FETCH_EDITCAREPROVIDERDATA_REJECTED,
    FETCH_EDITCAREPROVIDERDATA_PENDING,
    RESET_EDITCAREPROVIDERDATA
} from "../../actions/nurse/editCareProvider";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EDITCAREPROVIDERDATA_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_EDITCAREPROVIDERDATA_FULFILLED:
            return {
                ...state,
                editCareProviderData: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_EDITCAREPROVIDERDATA_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_EDITCAREPROVIDERDATA:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};